import { render, staticRenderFns } from "./zbindexJc.vue?vue&type=template&id=3c10cdd3&scoped=true"
import script from "./zbindexJc.vue?vue&type=script&lang=js"
export * from "./zbindexJc.vue?vue&type=script&lang=js"
import style0 from "./zbindexJc.vue?vue&type=style&index=0&id=3c10cdd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c10cdd3",
  null
  
)

export default component.exports